import { LogoMark } from "@mineoptics/brand/logo";
import { NumberFunnel } from "@/components/canvas/NumberFunnel";
import { PillLink } from "@/components/PillLink";
import { DOCS_URL } from "@/lib/site";

const POINTS = [
  {
    title: "Formulas are published.",
    body: "Burden, spacing, stiffness ratio, rigs required, minimum-curvature desurvey. Each result traces back to a documented formula with a worked example.",
  },
  {
    title: "Units stay in view.",
    body: "Metres, tonnes, hours and cost per tonne are labelled on every input and every result, with amounts in the currency your project states.",
  },
  {
    title: "Your rates, not ours.",
    body: "Drill presets and rock types are generic starting points. Replace them with your own figures, or fill them from a vendor quote.",
  },
];

export function Method() {
  return (
    <section data-theme="light" className="relative overflow-hidden bg-bg">
      <div className="shell grid gap-12 py-20 md:py-28 lg:grid-cols-2 lg:gap-10">
        <div className="flex flex-col">
          <p data-fade className="eyebrow eyebrow-mark mb-6 text-mute">
            Method
          </p>
          <h2 data-split className="title max-w-[10ch]">
            Arithmetic you can check.
          </h2>

          <ul className="mt-10 max-w-xl lg:mt-auto lg:pt-14">
            {POINTS.map((point) => (
              <li key={point.title}>
                <span data-rule className="rule" />
                <div data-fade className="grid gap-2 py-5 sm:grid-cols-[14rem_1fr] sm:gap-6">
                  <h3 className="font-medium tracking-[-0.01em]">{point.title}</h3>
                  <p className="text-mute">{point.body}</p>
                </div>
              </li>
            ))}
          </ul>

          <div data-fade className="mt-8">
            <PillLink to={`${DOCS_URL}/reference/formulas`} label="Read the formulas" arrow />
          </div>
        </div>

        <div data-fade className="relative flex min-h-[22rem] flex-col lg:min-h-[34rem]">
          <div className="relative flex-1">
            <NumberFunnel className="absolute inset-0 h-full w-full" />
          </div>
          <div className="flex flex-col items-center">
            <span className="h-10 w-px bg-fg/25" />
            <div data-theme="dark" className="flex items-center gap-4 rounded-full bg-bg py-3 pl-4 pr-8">
              <LogoMark className="h-10 w-10" />
              <div>
                <span className="eyebrow block text-mute">Many inputs, one answer</span>
                <span className="mt-1 block font-mono text-2xl font-medium tracking-[-0.03em] text-lime">$ / t</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
